import * as React from 'react';
import { DropdownButtonType, HierarchicalDropdownWidget, MenuItemInfo } from '@tableau/widgets';
import * as notificationStyles from '../styles/notificationStyles';
import { NotificationMenuItem } from '../contentProviders/IUserNotificationMenuItemProvider';
import { Icons } from './Icons';
import { Messages } from '../../codegen/Localize';
import { sendUserNotificationItemActionTelemetry, UserNotificationsTelemetryEvents } from '../telemetry/UserNotificationsTelemetry';

export interface NotificationActionsProps {
  notificationId: string;
  notificationType: string;
  actions: Array<NotificationMenuItem>;
  onKeyDown: (e: any) => void;
  closePanel: () => void;
  userId: string;
  siteLuid: string;
}

export function NotificationActions(props: NotificationActionsProps) {

  function createMenuItems(): MenuItemInfo[] {
    const menuItems: MenuItemInfo[] = [];
    props.actions.map((action, index) => menuItems.push({ displayValue: action.title, value: index.toString() }));
    return menuItems;
  }

  function onSelect(value: string) {
    const actionType = props.actions[Number(value)].title;
    sendUserNotificationItemActionTelemetry(UserNotificationsTelemetryEvents.notificationItemAction, props.userId, props.siteLuid, props.notificationType, actionType);
    props.actions[Number(value)].onClick();
    if(props.actions[Number(value)].closePanel){
      props.closePanel();
    }
  }

  function getIconButtonContent() {
    return <Icons.NotificationActionsMenu
      testId={'notificat-action-icon'}
      title={Messages.userNotificationsActions()} />;
  }

  return (
    <HierarchicalDropdownWidget
      aria-label={Messages.userNotificationsActions()}
      closeOnPopupBlur={false}
      testId={`notification-action-${props.notificationId}`}
      onSelect={onSelect}
      menuItemInfos={createMenuItems()}
      label={undefined}
      stackingRootId={'notification-panel'} // this is added as workaround of tfs1156753
      type={DropdownButtonType.Icon}
      children={getIconButtonContent()}
      className={notificationStyles.actionsButton}
      onKeyDown={props.onKeyDown}
      popupAlignment={'right'}
    />);
}
